<div class="card" 
  [ngClass]="{'card--checked': checked}">
  
  <div 
    class="card__image" 
    *ngIf="image"
    [defaultImage]="defaultImage"
    [lazyLoad]="image">

    <div class="card__hover hide-sm" *ngIf="showHover">
      <div class="card__header" appEventFence>
        <!-- Checkbox -->
        <div
          class="card__check theme-ghost" 
          [class.card__check--checked]="checked">
          <mat-checkbox *ngIf="checkable" (change)="handleCheckedChange($event)" [checked]="checked"></mat-checkbox>
        </div>
          
        <!-- Actions -->
        <div class="card__actions" appEventFence>
          <ng-content select="[card-actions]"></ng-content>
        </div>
      </div>
  
      <div class="card__meta">
        <ng-content select="[card-meta]"></ng-content>
      </div>

      <div class="card__hover-action">
        <ng-content select="[card-hover-action]"></ng-content>
      </div>
    </div>
  </div>
  
  <div class="card__body">
    <ng-content select="[card-body]"></ng-content>
  </div>

  
  <div class="card__footer">
    <ng-content select="[card-footer]"></ng-content>
  </div>

  


</div>